(() => {
  // Only run on product pages (defensive)
  if (!/\/products\//.test(location.pathname)) return;

  const SELECTOR_ZERO = '[data-number-of-reviews="0"]';
  const SELECTOR_REVIEW_BLOCKS = '.jdgm-widget, .jdgm-rev-widg, .jdgm-preview-badge, .jdgm-prev-badge, [id*="judgeme"], [class*="judgeme"]';

  function hideJudgeMeIfZero() {
    const zeros = document.querySelectorAll(SELECTOR_ZERO);
    if (!zeros.length) return false;

    // Hide the found zero-review widgets
    zeros.forEach(widget => {
      widget.style.display = 'none';

      // Hide containing section if present
      const section = widget.closest('section, .shopify-section, .jdgm-widget');
      if (section) section.style.display = 'none';
    });

    // Also hide any preview badges (under title, etc.)
    document.querySelectorAll('.jdgm-preview-badge, .jdgm-prev-badge').forEach(el => {
      el.style.display = 'none';
    });

    return true;
  }

  // 1) Try immediately (in case widgets are already present)
  if (hideJudgeMeIfZero()) return;

  // 2) Observe DOM changes for lazy-injected widgets/attributes
  const observer = new MutationObserver(mutations => {
    // If any new nodes/attribute changes match our criteria, act and stop
    for (const m of mutations) {
      if (
        (m.type === 'childList' && (m.addedNodes?.length || 0) > 0) ||
        (m.type === 'attributes' && m.attributeName === 'data-number-of-reviews')
      ) {
        if (hideJudgeMeIfZero()) {
          observer.disconnect();
          clearTimeout(killTimer);
          break;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-number-of-reviews']
  });

  // 3) Safety net: stop watching after 15s to avoid leaks
  const killTimer = setTimeout(() => observer.disconnect(), 15000);

  // 4) Extra safety: also try again on full window load
  window.addEventListener('load', () => hideJudgeMeIfZero());
})();